/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_02_Detail_Beginner_0_HeadingInputs */

const en_method_content_step_02_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permission to swing`)
};

const es_method_content_step_02_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permiso para swinguear`)
};

const de_method_content_step_02_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erlaubnis zum Schwingen`)
};

const zh_method_content_step_02_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`放心去挥杆`)
};

const ar_method_content_step_02_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إذن بالسوينغ`)
};

const fr_method_content_step_02_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permission de swinguer`)
};

const vi_method_content_step_02_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Được phép swing`)
};

const sw_method_content_step_02_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruhusa ya kupiga swing`)
};

const th_method_content_step_02_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณสวิงได้อย่างเป็นธรรมชาติ`)
};

const bs_method_content_step_02_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dozvola za swing`)
};

const ja_method_content_step_02_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自由にスイングしていい`)
};

const ko_method_content_step_02_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`마음껏 휘둘러도 됩니다`)
};

const pt_method_content_step_02_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liberdade para fazer o swing`)
};

const it_method_content_step_02_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il permesso di fare swing`)
};

const sv_method_content_step_02_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tillåtelse att svinga`)
};

const nl_method_content_step_02_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toestemming om te swingen`)
};

const da_method_content_step_02_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lov til at svinge`)
};

const nb_method_content_step_02_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lov til å svinge`)
};

const fi_method_content_step_02_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lupa svingata`)
};

const pl_method_content_step_02_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pozwolenie na swing`)
};

const ru_method_content_step_02_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разрешение делать свинг`)
};

const tr_method_content_step_02_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swing yapma izni`)
};

const hi_method_content_step_02_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खुलकर स्विंग करने की छूट`)
};

const id_method_content_step_02_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Izin untuk mengayun`)
};

const ms_method_content_step_02_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kebenaran untuk menghayun`)
};

const cs_method_content_step_02_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Svolení švihnout`)
};

const el_method_content_step_02_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Άδεια να κάνετε σβινγκ`)
};

const he_method_content_step_02_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`רשות לחבוט בחופשיות`)
};

const af_method_content_step_02_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toestemming om te swaai`)
};

const hu_method_content_step_02_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szabad lendítened`)
};

/**
* | output |
* | --- |
* | "Permission to swing" |
*
* @param {Method_Content_Step_02_Detail_Beginner_0_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_02_detail_beginner_0_heading = /** @type {((inputs?: Method_Content_Step_02_Detail_Beginner_0_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_02_Detail_Beginner_0_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_02_detail_beginner_0_heading(inputs)
	if (locale === "de") return de_method_content_step_02_detail_beginner_0_heading(inputs)
	if (locale === "zh") return zh_method_content_step_02_detail_beginner_0_heading(inputs)
	if (locale === "ar") return ar_method_content_step_02_detail_beginner_0_heading(inputs)
	if (locale === "fr") return fr_method_content_step_02_detail_beginner_0_heading(inputs)
	if (locale === "vi") return vi_method_content_step_02_detail_beginner_0_heading(inputs)
	if (locale === "sw") return sw_method_content_step_02_detail_beginner_0_heading(inputs)
	if (locale === "th") return th_method_content_step_02_detail_beginner_0_heading(inputs)
	if (locale === "bs") return bs_method_content_step_02_detail_beginner_0_heading(inputs)
	if (locale === "ja") return ja_method_content_step_02_detail_beginner_0_heading(inputs)
	if (locale === "ko") return ko_method_content_step_02_detail_beginner_0_heading(inputs)
	if (locale === "pt") return pt_method_content_step_02_detail_beginner_0_heading(inputs)
	if (locale === "it") return it_method_content_step_02_detail_beginner_0_heading(inputs)
	if (locale === "sv") return sv_method_content_step_02_detail_beginner_0_heading(inputs)
	if (locale === "nl") return nl_method_content_step_02_detail_beginner_0_heading(inputs)
	if (locale === "da") return da_method_content_step_02_detail_beginner_0_heading(inputs)
	if (locale === "nb") return nb_method_content_step_02_detail_beginner_0_heading(inputs)
	if (locale === "fi") return fi_method_content_step_02_detail_beginner_0_heading(inputs)
	if (locale === "pl") return pl_method_content_step_02_detail_beginner_0_heading(inputs)
	if (locale === "ru") return ru_method_content_step_02_detail_beginner_0_heading(inputs)
	if (locale === "tr") return tr_method_content_step_02_detail_beginner_0_heading(inputs)
	if (locale === "hi") return hi_method_content_step_02_detail_beginner_0_heading(inputs)
	if (locale === "id") return id_method_content_step_02_detail_beginner_0_heading(inputs)
	if (locale === "ms") return ms_method_content_step_02_detail_beginner_0_heading(inputs)
	if (locale === "cs") return cs_method_content_step_02_detail_beginner_0_heading(inputs)
	if (locale === "el") return el_method_content_step_02_detail_beginner_0_heading(inputs)
	if (locale === "he") return he_method_content_step_02_detail_beginner_0_heading(inputs)
	if (locale === "af") return af_method_content_step_02_detail_beginner_0_heading(inputs)
	if (locale === "hu") return hu_method_content_step_02_detail_beginner_0_heading(inputs)
	return en_method_content_step_02_detail_beginner_0_heading(inputs)
});